import React, { useState } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../Icon';
import styles from './index.styl';

const SimpleAvatar = ({
  src,
  text,
  size,
  unverified,
  iconRatio,
  fontRatio,
  disabled,
  waiting,
  bordered,
  className,
  usePercent,
  opaque,
  white,
  onClick,
  onError,
}) => {
  const [error, setError] = useState(false);
  const hasIcon = waiting || unverified;
  const additionalIcon = unverified ? 'error' : 'icon-time';

  const handleError = () => {
    setError(true);
    onError();
  };

  const avatarSize = usePercent ? `${size}%` : `${size}px`;
  const fontSize = usePercent ? 'calc(20px + 2vw)' : size * fontRatio;

  return (
    <div
      styleName={cn('root', {
        'root--bordered': bordered,
        'root--opaque': opaque,
        'root--white': white,
      })}
      style={{
        width: avatarSize,
        height: avatarSize,
        fontSize,
      }}
      className={className}
      title={text}
      onClick={onClick}
    >
      <If condition={src && !error}>
        <div
          styleName={cn('image', {
            'image--disabled': disabled || waiting,
          })}
          style={{
            backgroundImage: `url(${src})`,
          }}
          alt="avatar"
          onError={handleError}
        />
        <Else />
        <If condition={text}>
          <span>{text[0].toUpperCase()}</span>
        </If>
      </If>
      <If condition={hasIcon}>
        <div styleName="iconWaiting">
          <Icon name={additionalIcon} size={iconRatio * size} />
        </div>
      </If>
    </div>
  );
};

SimpleAvatar.propTypes = {
  src: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.number,
  disabled: PropTypes.bool,
  bordered: PropTypes.bool,
  waiting: PropTypes.bool,
  opaque: PropTypes.bool,
  white: PropTypes.bool,
  usePercent: PropTypes.bool,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  iconRatio: PropTypes.number,
  fontRatio: PropTypes.number,
  className: PropTypes.string,
  unverified: PropTypes.bool,
};

SimpleAvatar.defaultProps = {
  size: 24,
  iconRatio: 0.4,
  fontRatio: 0.6,
  className: '',
};

export default CSSModules(SimpleAvatar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/SimpleAvatar/index.jsx